module.exports = __webpack_public_path__ + "img/banner3.51f9764d.png";